<!--
 * @Description: 熱門測試排行榜 -- 移動端
 * @Author: xiuwen
 * @Date: 2024-12-25 17:28:10
 * @LastEditors: xiuwen
 * @LastEditTime: 2025-06-23 18:16:35
-->
<template>
	<section class="m-card">
		<header class="m-card-header">
			<h2 class="m-card-title">熱門測算排行榜</h2>
			<!-- <button class="more-btn" type="button" aria-label="查看更多測試">
				<span>&gt;</span>
			</button> -->
		</header>
		<ul class="m-card-content">
			<article
				class="m-card-item"
				v-for="item in rankList"
				:key="item.id"
				@click="goLink(item.jump_url, 'calc-ranking-m')"
			>
				<div class="m-card-item-top">
					<div class="m-card-item-left">
						<van-image class="cover" :src="item.icon" :alt="item.title" />
					</div>
					<div class="m-card-item-right">
						<h3 class="name">{{ item.title }}</h3>
						<p class="desc">{{ item.description || "讓你掌握未來、趨吉避凶！" }}</p>
					</div>
				</div>

				<div class="m-card-item-bottom">
					<div class="zan">
						<img :src="goodIcon" alt="" />
						{{ item.zan || 8567 }}
					</div>

					<div class="score">
						<div class="stars">
							<img v-for="starIndex in 5" :key="starIndex" :src="starIcon" alt="" />
						</div>
						<span>{{ formatScore(item.score) }}</span>
					</div>
				</div>
			</article>
		</ul>
	</section>
</template>

<script setup>
import { computed } from "vue";
import { getCalculateRank } from "~/api/api";
import { goLink } from "~/utils/common";
import goodIcon from "../../images/good.png";
import starIcon from "../../images/star.png";

const { data } = await useLazyAsyncData(
	"onlinecs-question-rank",
	async () => {
		try {
			const res = await getCalculateRank();
			return res.data.map(item => {
				return {
					...item,
					jump_url: item.index_uri,
				};
			});
		} catch (error) {
			console.error("加载数据失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

const rankList = computed(() => data.value.slice(0, 5));

const formatScore = score => {
	const value = Number(score);
	if (!value) {
		return "5.0";
	}
	return (value > 5 ? value / 2 : value).toFixed(1);
};
</script>

<style lang="scss" scoped>
.m-card {
	width: 686px;
	min-height: 860px;
	padding: 16px 0px 0;
	box-sizing: border-box;
	font-family: PingFang SC;
	background-color: #ffffff;
	border-radius: 16px;

	.m-card-header {
		padding: 0 4px 24px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.m-card-title {
		font-weight: 600;
		font-size: 36px;
		color: #333333;
		line-height: 60px;
	}

	.more-btn {
		width: 38px;
		height: 38px;
		padding: 0;
		border: 1px solid #d9d9d9;
		border-radius: 50%;
		background: #ffffff;
		color: #999999;
		font-size: 28px;
		line-height: 34px;
		text-align: center;
		pointer-events: none;
	}

	.m-card-content {
		display: flex;
		flex-direction: column;
		gap: 16px;
		// padding-bottom: 28px;

		.m-card-item {
			padding: 16px;
			background-color: #ffffff;
			border: 1px solid #e9e9e9;
			border-radius: 12px;
			cursor: pointer;
			display: flex;
			flex-direction: column;
			gap: 12px;

			.m-card-item-top {
				display: flex;
				gap: 16px;

				.m-card-item-left {
					.cover {
						width: 108px;
						height: 108px;
						border-radius: 8px;
						overflow: hidden;
					}
				}

				.m-card-item-right {
					flex: 1;
					min-width: 0;
					.name {
						margin: 0;
						font-weight: 600;
						font-size: 28px;
						color: #2b2f36;
						line-height: 40px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.desc {
						margin: 6px 0 0;
						font-weight: 400;
						font-size: 24px;
						color: #646a73;
						line-height: 34px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						line-clamp: 2;
					}
				}
			}

			.m-card-item-bottom {
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 24px;
				color: #666666;
				line-height: 32px;

				.zan,
				.score,
				.stars {
					display: flex;
					align-items: center;
				}

				.zan img {
					width: 22px;
					height: 22px;
					margin-right: 8px;
				}

				.score {
					gap: 10px;
				}

				.stars {
					gap: 2px;

					img {
						width: 18px;
						height: 18px;
					}
				}
			}
		}
	}
}
</style>
